import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminLogin from "../pages/admin-login/page";
import CustomerLogin from "../pages/customer-login/page";
import AdminDashboard from "../pages/admin-dashboard/page";
import CustomerDashboard from "../pages/customer-dashboard/page";
import CartPage from "../pages/cart/page";
import BankTransferPage from "../pages/bank-transfer/page";
import PublicSurvey from "../pages/public-survey/page";
import PublicQuote from "../pages/public-quote/page";
import { lazy, Suspense } from "react";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/customer-login",
    element: <CustomerLogin />,
  },
  {
    path: "/admin-dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/customer-dashboard",
    element: <CustomerDashboard />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/bank-transfer",
    element: <BankTransferPage />,
  },
  {
    path: "/survey/:shareId",
    element: <PublicSurvey />,
  },
  {
    path: "/quote/:shareId",
    element: <PublicQuote />,
  },
  {
    path: "/admin-paytr-settings",
    element: <AdminPayTRSettings />,
  },
  {
    path: "/admin-bank-settings",
    element: <AdminBankSettings />,
  },
  {
    path: "/admin-live-support",
    element: <AdminLiveSupport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

function AdminPayTRSettings() {
  const Component = lazy(() => import("../pages/admin-paytr-settings/page"));
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      }
    >
      <Component />
    </Suspense>
  );
}

function AdminBankSettings() {
  const Component = lazy(() => import("../pages/admin-bank-settings/page"));
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      }
    >
      <Component />
    </Suspense>
  );
}

function AdminLiveSupport() {
  const Component = lazy(() => import("../pages/admin-live-support/page"));
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
        </div>
      }
    >
      <Component />
    </Suspense>
  );
}

export default routes;
